module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0070.jpg?v=85c305ec";